module.exports = __webpack_public_path__ + "static/img/23.bf1e48b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/23.jpg
// module id = nH+y
// module chunks = 0